/* eslint-disable sort-keys-fix/sort-keys-fix, typescript-sort-keys/interface, camelcase */
/*
 * This code is generated by ../../../scripts/generateSchemas.ts.
 * Do not adapt manually. Instead run 'yarn generate'.
 *
 * Source: ../../types/video-exercise/v0.ts
 */

import { createValidator } from '../../helpers/validator';
export const VideoExerciseV0Schema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  type: 'object',
  properties: {
    title: {
      type: 'string'
    },
    xp: {
      type: 'number'
    },
    course_id: {
      type: 'number'
    },
    chapter_id: {
      type: 'number'
    },
    assignment: {
      type: ['string', 'null']
    },
    projector_key: {
      type: ['string', 'null']
    },
    video_hls: {
      type: ['string', 'null']
    },
    video_link: {
      type: ['string', 'null']
    }
  },
  required: ['chapter_id', 'course_id', 'title', 'xp'],
  definitions: {}
};
export const isValidVideoExerciseV0 = createValidator(VideoExerciseV0Schema);
export const VideoExerciseV0Definition = {
  schema: VideoExerciseV0Schema,
  validate: isValidVideoExerciseV0
};